// A route/query id as a Number, or null when it is not a canonical positive
// integer ("12" yes; "0", "-1", "007", "1.5", "abc" no) — so a malformed link
// never reaches the API as a request.
export function toPositiveInt(value) {
  if (typeof value !== "string" || !/^[1-9]\d*$/.test(value)) return null;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed <= 2147483647 ? parsed : null;
}
